<script>
//import store from '@/store';
import { loadingLgIcon } from '@/utils/proposalIcons';

export default {
    name: "PreviewTemplates",
    props: {
        isPreviewable: {
            type: Boolean,
            default: false
        },
        emptyMessage: {
            type: String,
            default: 'Select template to preview'
        },
    },
    data() {
        return {
            loadingLgIcon
        };
    },
    computed: {
        loading() {
            return this.$store.state.loading.spellCheck;
        }
    }
};
</script>

<template>
    <div class="preview-section">
        <h4 class="mb-3 font-weight-bold">Preview</h4>
        <div class="preview-container ">

            <div v-show="loading" class=" white-page-loader">
                <div class="spinner-container">
                    <span class="export-spinner" v-html="loadingLgIcon" />
                    <p>Generating preview...</p>
                </div>
            </div>

            <div v-show="!loading && isPreviewable" class="preview-content">
                <slot></slot>
            </div>

            <p v-show="!loading && !isPreviewable" class="preview-text">
                {{ emptyMessage }}
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">
.preview-container {
    display: flex;
    flex-direction: column;
    min-height: 200px;
    width: 100%;
    align-items: center;
    justify-content: center;
    overflow: auto;
    border: 1px solid #dee2e6;
    background-color: #f8f9fa;
}

.white-page-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 200px;
}

.spinner-container {
    text-align: center;

    .export-spinner {
        display: inline-block;
        animation: spin 1s linear infinite;
        color: #4475b4;
    }

    p {
        padding-top: 10px;
        color: #4475b4;
        font-weight: bold;
        font-size: 16px;
        margin: 0;
    }
}

.preview-content {
    margin: 4px auto;
}

.preview-text {
    color: #727070;
    font-size: 12px;
    margin: 0;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>
